import { Api } from '../../utils/config';
import { Http } from '../../utils/http';
import { Cookie } from '../../utils/cookie'
import { GetClientType } from '../../utils/env'

const authToken = Cookie.get()
const unionId = Cookie.get(Cookie.WECHATIDKEY)

const getCommentList = async (id: number | string, page: number, limit: number) => {
    let url = Api().host + "/commentcenter/v1/comment/list";
    url += `?topic_type=vote-comment&topic_id=${id}&token=${authToken}&page=${page}&limit=${limit}`
    const data = await Http.get(url)
    return data;
}

const getUserList = async (ids: string) => {
    const url = Api().host + "/usercenter/get_public_user_info_list?user_ids=" + `${ids}`
    const data = await Http.get(url)
    return data;
}
const isSupport = async (sendId: number, sup: number) => {
    const url = Api().host + "/commentcenter/v1/comment/support";
    const body = Http.jsonToForm({
        auth_token: authToken,
        id: sendId,
        support: sup
    })
    const data = await Http.post(url, body)
    return data
}
const creatComment = async (objid: string, str: string) => {
    const url = Api().host + "/commentcenter/v1/comment/add";
    const body = Http.jsonToForm({
        ip: "",
        topic_type: 'vote-comment',
        topic_id: objid,
        content: str,
        auth_token: authToken
    })
    const data = await Http.post(url, body)
    return data
}
// 获取活动详情
const getActivityDetailInfo = async (id: number) => {
    const url = Api().host + `/votecenter/activity/${id}/info` +
        `?user_token=${authToken}` +
        `&union_id=${unionId}` +
        `&client_type=${GetClientType()}`
    const data = await Http.get(url)
    return data;
}
// 获取分组下的活动列表
const getGroupActivityList = async (id: number) => {
    const url = Api().host + '/votecenter/groups/activity_list' +
        `?group_id=${id}`
    const data = await Http.get(url)
    return data;
}

export {
    getCommentList,
    getUserList,
    isSupport,
    creatComment,
    getActivityDetailInfo,
    getGroupActivityList
}


// WEBPACK FOOTER //
// ./src/components/activity_comment/api.ts